module.exports = __webpack_public_path__ + "img/auth-logo.png";